<template>
	<div
		class="property-form"
		:class="{ 'shrink': !isVisible }">
		<div class="d-flex align-items-start justify-content-between">
			<div v-if="isLoading" class="absolute loader-circle">
				<div class="is-loading"></div>
			</div>
			<div class="property-title">
				{{ $t('Custom Zoom Properties') }} - {{ label ? label.toUpperCase() : 'DEFAULT ZOOM PROPERTY' }}
			</div>
		</div>
			<div class="property-content" :class="{'pointer-events-none': isLocked ? isLocked.is_locked : true, 'bg-color-editing': isUserEditing !== user.id && isUserEditing}">
				<div class="form-group mb-5">
					<label class="text-primary">{{ $t('Zoom Meeting Property') }}</label>
					<custom-input
							class="mb-3"
							align="left"
							:label="$t('Label')"
							:required="isRequired"
							@input="onKeywordChange"
							v-model="label"/>
					<div class="row">
						<div class="col-md-12">
							<custom-input
							class="mb-3"
							align="left"
							:label="$t('Zoom Display Name')"
							:required="isRequired"
							@input="onKeywordChange"
							v-model="meetingDisplayName"/>
						</div>
						<div class="col-md-12">
							<custom-input
							class="mb-3"
							align="left"
							:label="$t('Zoom Meeting Number')"
							:required="isRequired"
							@input="onKeywordChange"
							v-model="meetingNumber"/>
						</div>
						<div class="col-md-12">
							<custom-input
							class="mb-3"
							align="left"
							:label="$t('Zoom Meeting Password')"
							:required="isRequired"
							@input="onKeywordChange"
							v-model="meetingPassword"/>
						</div>
						<div class="col-md-12">
							<custom-select
							class="mb-3"
							:label="$t('Zoom Meeting Role')"
							:options="zoomRoleOptions"
							v-model="meetingRole"
							@input="onKeywordChange"
							/>
						</div>
						<div class="col-md-6 pr-5px mb-4">
							<custom-input
								type="number"
								class="form-control"
								field="index"
								:label="$t('Layer')"
								:required="isRequired"
								:max="100"
								:index-duplicated="isIndexDuplicated"
								@input="onKeywordChange"
								v-model="layerIndex"
							/>
						</div>
					</div>
					<div class="form-group mt-2">
						<position-settings
							:width.sync="width"
							:height.sync="height"
							:position.sync="position"
							:isRatio.sync="isRatio"
							:x.sync="x"
							:y.sync="y"
							@reset="resetSizePosition"
							@change="onKeywordChange"
						/>
					</div>
				</div>
			</div>
	</div>
</template>

<script>

import rundownItemsApi from '@/api/rundownItems';
import { delay } from '@/lib/helper';
import CustomInput from '@/components/CustomInput.vue';
import PositionSettings from '@/components/PositionSettings.vue';
import CustomSelect from '@/components/CustomSelect.vue';

import {
	zoomRoleOptions,
} from '@/lib/statics';

export default {
	name: 'ZoomProperty',
	props: {
		data: {
			type: Object,
		},
		rundown: {
			type: Object,
		},
		zoom: {
			type: Object,
		},
		filteredItems: {
			type: Array,
		},
		items: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		CustomInput,
		PositionSettings,
		CustomSelect,
	},
	data() {
		return {
			zoomRoleOptions,
			isLoading: false,
			meetingDisplayName: 'DEFAULT ZOOM MEETING NAME',
			meetingNumber: '',
			meetingPassword: '',
			meetingRole: '',
			label: '',
			layerIndex: 0,
			width: 0,
			height: 0,
			position: '',
			x: 0,
			y: 0,
			type: 'zoom_meeting',
			progress: 0,
			isUploading: false,
			isSaving: false,
			isVisible: true,
			isRequired: false,
			isRatio: true,
		};
	},
	methods: {
		initData() {
			this.isVisible = true;
			// this.reset();
			if (this.data) {
				let content = this.data.content;
				if (typeof content === 'string') {
					content = JSON.parse(content);
				}
				this.label = this.data.name;
				this.meetingDisplayName = content && content.meetingDisplayName ? content.meetingDisplayName : '';
				this.meetingNumber = content && content.meetingNumber ? content.meetingNumber : '';
				this.meetingPassword = content && content.meetingPassword ? content.meetingPassword : '';
				this.meetingRole = content && content.meetingRole ? content.meetingRole : '';
				this.layerIndex = this.data.layer_index;
				this.width = content && content.width ? content.width : 1920;
				this.height = content && content.height ? content.height : 1080;
				this.position = content && content.position ? content.position : 'default';
				this.isRatio = content && content.isRatio ? content.isRatio : false;
				this.x = content && content.x ? content.x : 0;
				this.y = content && content.y ? content.y : 0;
			}
		},
		reset() {
			this.meetingDisplayName = '';
			this.meetingNumber = '';
			this.meetingPassword = '';
			this.meetingRole = '';
			this.label = '';
			this.layerIndex = 0;
			this.width = 1920;
			this.height = 1080;
			this.position = 'default';
			this.x = 0;
			this.y = 0;
		},
		onKeywordChange() {
			delay(() => {
				// this.fetch(true);
				this.saveFromInput();
			}, 1200);
		},
		saveFromInput() {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
			};
			const errorCallback = () => {
				this.isSaving = false;
			};
			rundownItemsApi.update(this.data.id, this.zoomParams, callback, errorCallback);
		},
		checkDuplicateIndex() {
			const valueArr = this.filteredItems.map(a => a.layer_index);
			let count = 0;
			for (let i = 0; i < valueArr.length; ++i) {
				if (valueArr[i] === this.layerIndex) count++;
			}
			if (count > 1) {
				return true;
			}
			return false;
		},
		duplicateLayerText() {
			const text1 = 'Other item also using this layer, only one item at a time will be displayed';
			return text1;
		},
		resetSizePosition() {
			this.x = 0;
			this.y = 0;
			this.position = 'default';
			this.width = 1920;
			this.height = 1080;
			this.saveFromInput();
		},
	},
	computed: {
		zoomParams() {
			const content = {
				type: this.type,
				meetingDisplayName: this.meetingDisplayName,
				meetingNumber: this.meetingNumber,
				meetingPassword: this.meetingPassword,
				meetingRole: this.meetingRole,
				label: this.label,
				layerIndex: this.layerIndex,
				width: this.width,
				height: this.height,
				position: this.position,
				isRatio: this.isRatio,
				x: this.x,
				y: this.y,
			};
			const contentString = JSON.stringify(content);
			const params = {
				name: this.label,
				type: this.type,
				content: contentString,
				layer_index: this.layerIndex,
				rundown_id: this.rundownId,
				// status: 1,
				// is_play_live: 0,
				// is_play_preview: 0,
				// is_shy: 0,
			};
			return params;
		},
		rundownId() {
			return this.rundown ? this.rundown.id : 0;
		},
		isIndexDuplicated() {
			if (this.data) {
				// eslint-disable-next-line
				const filter = (({ id, layer_index }) => id !== this.data.id && layer_index === this.layerIndex);
				const duplicateItems = this.items.filter(filter);
				return duplicateItems.length > 0;
			}
			return false;
		},
		isLocked() {
			const index = this.items.findIndex(({ id }) => id === this.data.id);
			return this.items[index];
		},
		isUserEditing() {
			const index = this.items.findIndex(({ id }) => id === this.data.id);
			return this.items[index] ? this.items[index].active_edit : null;
		},
	},
	created() {
		this.isRequired = false;
		this.isLoading = true;
		this.$nextTick(() => {
			this.initData();
		});
		setTimeout(() => {
			this.isLoading = false;
			this.isRequired = true;
		}, 400);
	},
};
</script>
